import { Cross } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ISectionProps } from "@/interfaces/section-props.interface";

const SubscribeComponent = ({ fnOnScrollToOne }: ISectionProps) => {
  return (
    <section className="py-12 px-4 custom-bg-color-linear-gradient-color-04-to-color-03">
      <div className="max-w-4xl mx-auto text-center custom-color-01">
        <Cross className="w-16 h-16 mx-auto mb-6 opacity-80 text-white" />
        <h3 className="text-3xl md:text-4xl font-bold mb-6">
          Garanta sua inscrição e invista em uma formação que faz diferença na
          vida real
        </h3>
        
        <Button
          size="lg"
          className="px-12 py-4 text-xl rounded-full font-semibold text-black hover:opacity-90 cursor-pointer custom-bg-color-01"
          onClick={fnOnScrollToOne}
        >
          Quero participar
        </Button>

        <p className="mt-6 custom-color-01" style={{ opacity: 0.9 }}>
          Transforme vidas através da suficiência das Escrituras
        </p>
      </div>
    </section>
  );
};
export default SubscribeComponent;
